/*
  Edit dialogs: A/B test (PUT /api/ab-tests/{id}), domain pool
  (PATCH /api/domain-pools/{id}), ad-account connection
  (PUT /api/ad-account-connections/{id}).
  Merged FIRST into TRANSLATION_MAPS in ./index.js. Keys are the English source.
*/

const ru = {
  "Edit A/B test": "Изменить A/B-тест",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Варианты и распределение трафика менять нельзя: это смешает уже собранные результаты. Чтобы проверить другие варианты, создайте новый тест.",
  "Test name": "Название теста",
  "Test description": "Описание теста",
  "Confidence level, %": "Уровень доверия, %",
  "Minimum sample size": "Минимальная выборка",
  "Auto-optimization": "Автооптимизация",
  "The test is running: the changes apply right away.": "Тест запущен: изменения применятся сразу.",
  "A/B test saved": "A/B-тест сохранён",
  "Could not save the A/B test": "Не удалось сохранить A/B-тест",
  "Edit domain pool": "Изменить пул доменов",
  "Links already given out keep working; the changes apply to new links.": "Уже выданные ссылки продолжают работать; изменения касаются новых ссылок.",
  "Pool name": "Название пула",
  "Pool strategy": "Стратегия пула",
  "Pool domains": "Домены пула",
  "Choose at least one domain.": "Выберите хотя бы один домен.",
  "Pool description": "Описание пула",
  "Domain pool saved": "Пул доменов сохранён",
  "Could not save the domain pool": "Не удалось сохранить пул доменов",
  "Edit connection": "Изменить подключение",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Токены не показываются. Чтобы заменить токен, нажмите «Обновить токен» или подключите аккаунт заново.",
  "Connection name": "Название подключения",
  "Import cost from this account": "Загружать расходы из этого аккаунта",
  "Off: cost sync skips this account; the connection is kept.": "Выключено: синхронизация расходов пропускает аккаунт, подключение сохраняется.",
  "Connection saved": "Подключение сохранено",
  "Could not save the connection": "Не удалось сохранить подключение",
  "Edit item": "Изменить",
};

const es = {
  "Edit A/B test": "Editar test A/B",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Las variantes y el reparto de tráfico no se pueden cambiar: eso mezclaría los resultados ya recogidos. Para probar otras variantes, crea un test nuevo.",
  "Test name": "Nombre del test",
  "Test description": "Descripción del test",
  "Confidence level, %": "Nivel de confianza, %",
  "Minimum sample size": "Tamaño mínimo de muestra",
  "Auto-optimization": "Optimización automática",
  "The test is running: the changes apply right away.": "El test está en marcha: los cambios se aplican de inmediato.",
  "A/B test saved": "Test A/B guardado",
  "Could not save the A/B test": "No se pudo guardar el test A/B",
  "Edit domain pool": "Editar pool de dominios",
  "Links already given out keep working; the changes apply to new links.": "Los enlaces ya entregados siguen funcionando; los cambios aplican a enlaces nuevos.",
  "Pool name": "Nombre del pool",
  "Pool strategy": "Estrategia del pool",
  "Pool domains": "Dominios del pool",
  "Choose at least one domain.": "Elige al menos un dominio.",
  "Pool description": "Descripción del pool",
  "Domain pool saved": "Pool de dominios guardado",
  "Could not save the domain pool": "No se pudo guardar el pool de dominios",
  "Edit connection": "Editar conexión",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Los tokens no se muestran. Para cambiar un token, usa Actualizar token o conecta la cuenta de nuevo.",
  "Connection name": "Nombre de la conexión",
  "Import cost from this account": "Importar costes de esta cuenta",
  "Off: cost sync skips this account; the connection is kept.": "Desactivado: la sincronización de costes omite esta cuenta; la conexión se conserva.",
  "Connection saved": "Conexión guardada",
  "Could not save the connection": "No se pudo guardar la conexión",
  "Edit item": "Editar",
};

const pt = {
  "Edit A/B test": "Editar teste A/B",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "As variantes e a divisão de tráfego não podem ser alteradas: isso misturaria os resultados já coletados. Para testar outras variantes, crie um teste novo.",
  "Test name": "Nome do teste",
  "Test description": "Descrição do teste",
  "Confidence level, %": "Nível de confiança, %",
  "Minimum sample size": "Tamanho mínimo da amostra",
  "Auto-optimization": "Otimização automática",
  "The test is running: the changes apply right away.": "O teste está rodando: as mudanças valem na hora.",
  "A/B test saved": "Teste A/B salvo",
  "Could not save the A/B test": "Não foi possível salvar o teste A/B",
  "Edit domain pool": "Editar pool de domínios",
  "Links already given out keep working; the changes apply to new links.": "Links já entregues continuam funcionando; as mudanças valem para links novos.",
  "Pool name": "Nome do pool",
  "Pool strategy": "Estratégia do pool",
  "Pool domains": "Domínios do pool",
  "Choose at least one domain.": "Escolha pelo menos um domínio.",
  "Pool description": "Descrição do pool",
  "Domain pool saved": "Pool de domínios salvo",
  "Could not save the domain pool": "Não foi possível salvar o pool de domínios",
  "Edit connection": "Editar conexão",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Os tokens não são exibidos. Para trocar um token, use Atualizar token ou conecte a conta de novo.",
  "Connection name": "Nome da conexão",
  "Import cost from this account": "Importar custos desta conta",
  "Off: cost sync skips this account; the connection is kept.": "Desligado: a sincronização de custos pula esta conta; a conexão é mantida.",
  "Connection saved": "Conexão salva",
  "Could not save the connection": "Não foi possível salvar a conexão",
  "Edit item": "Editar",
};

const de = {
  "Edit A/B test": "A/B-Test bearbeiten",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Varianten und Traffic-Aufteilung lassen sich nicht ändern: Das würde die bereits gesammelten Ergebnisse vermischen. Für andere Varianten leg einen neuen Test an.",
  "Test name": "Name des Tests",
  "Test description": "Beschreibung des Tests",
  "Confidence level, %": "Konfidenzniveau, %",
  "Minimum sample size": "Mindeststichprobe",
  "Auto-optimization": "Auto-Optimierung",
  "The test is running: the changes apply right away.": "Der Test läuft: Die Änderungen gelten sofort.",
  "A/B test saved": "A/B-Test gespeichert",
  "Could not save the A/B test": "Der A/B-Test konnte nicht gespeichert werden",
  "Edit domain pool": "Domain-Pool bearbeiten",
  "Links already given out keep working; the changes apply to new links.": "Bereits ausgegebene Links funktionieren weiter; die Änderungen gelten für neue Links.",
  "Pool name": "Name des Pools",
  "Pool strategy": "Pool-Strategie",
  "Pool domains": "Domains des Pools",
  "Choose at least one domain.": "Wähle mindestens eine Domain.",
  "Pool description": "Beschreibung des Pools",
  "Domain pool saved": "Domain-Pool gespeichert",
  "Could not save the domain pool": "Der Domain-Pool konnte nicht gespeichert werden",
  "Edit connection": "Verbindung bearbeiten",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Tokens werden nicht angezeigt. Um ein Token zu ersetzen, nutze Token aktualisieren oder verbinde das Konto neu.",
  "Connection name": "Name der Verbindung",
  "Import cost from this account": "Kosten aus diesem Konto importieren",
  "Off: cost sync skips this account; the connection is kept.": "Aus: Die Kostensynchronisierung überspringt dieses Konto; die Verbindung bleibt erhalten.",
  "Connection saved": "Verbindung gespeichert",
  "Could not save the connection": "Die Verbindung konnte nicht gespeichert werden",
  "Edit item": "Bearbeiten",
};

const fr = {
  "Edit A/B test": "Modifier le test A/B",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Les variantes et la répartition du trafic ne peuvent pas être modifiées : cela mélangerait les résultats déjà collectés. Pour essayer d’autres variantes, créez un nouveau test.",
  "Test name": "Nom du test",
  "Test description": "Description du test",
  "Confidence level, %": "Niveau de confiance, %",
  "Minimum sample size": "Taille minimale de l’échantillon",
  "Auto-optimization": "Optimisation automatique",
  "The test is running: the changes apply right away.": "Le test est en cours : les modifications s’appliquent tout de suite.",
  "A/B test saved": "Test A/B enregistré",
  "Could not save the A/B test": "Impossible d’enregistrer le test A/B",
  "Edit domain pool": "Modifier le pool de domaines",
  "Links already given out keep working; the changes apply to new links.": "Les liens déjà donnés continuent de fonctionner ; les modifications s’appliquent aux nouveaux liens.",
  "Pool name": "Nom du pool",
  "Pool strategy": "Stratégie du pool",
  "Pool domains": "Domaines du pool",
  "Choose at least one domain.": "Choisissez au moins un domaine.",
  "Pool description": "Description du pool",
  "Domain pool saved": "Pool de domaines enregistré",
  "Could not save the domain pool": "Impossible d’enregistrer le pool de domaines",
  "Edit connection": "Modifier la connexion",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Les jetons ne sont pas affichés. Pour remplacer un jeton, utilisez Actualiser le jeton ou reconnectez le compte.",
  "Connection name": "Nom de la connexion",
  "Import cost from this account": "Importer les coûts de ce compte",
  "Off: cost sync skips this account; the connection is kept.": "Désactivé : la synchronisation des coûts ignore ce compte ; la connexion est conservée.",
  "Connection saved": "Connexion enregistrée",
  "Could not save the connection": "Impossible d’enregistrer la connexion",
  "Edit item": "Modifier",
};

const it = {
  "Edit A/B test": "Modifica test A/B",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Varianti e ripartizione del traffico non si possono cambiare: si mescolerebbero i risultati già raccolti. Per provare altre varianti, crea un nuovo test.",
  "Test name": "Nome del test",
  "Test description": "Descrizione del test",
  "Confidence level, %": "Livello di confidenza, %",
  "Minimum sample size": "Dimensione minima del campione",
  "Auto-optimization": "Ottimizzazione automatica",
  "The test is running: the changes apply right away.": "Il test è in corso: le modifiche valgono subito.",
  "A/B test saved": "Test A/B salvato",
  "Could not save the A/B test": "Impossibile salvare il test A/B",
  "Edit domain pool": "Modifica pool di domini",
  "Links already given out keep working; the changes apply to new links.": "I link già dati continuano a funzionare; le modifiche valgono per i nuovi link.",
  "Pool name": "Nome del pool",
  "Pool strategy": "Strategia del pool",
  "Pool domains": "Domini del pool",
  "Choose at least one domain.": "Scegli almeno un dominio.",
  "Pool description": "Descrizione del pool",
  "Domain pool saved": "Pool di domini salvato",
  "Could not save the domain pool": "Impossibile salvare il pool di domini",
  "Edit connection": "Modifica connessione",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "I token non vengono mostrati. Per sostituire un token usa Aggiorna token o ricollega l’account.",
  "Connection name": "Nome della connessione",
  "Import cost from this account": "Importa i costi da questo account",
  "Off: cost sync skips this account; the connection is kept.": "Disattivato: la sincronizzazione dei costi salta questo account; la connessione resta.",
  "Connection saved": "Connessione salvata",
  "Could not save the connection": "Impossibile salvare la connessione",
  "Edit item": "Modifica",
};

const pl = {
  "Edit A/B test": "Edytuj test A/B",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Wariantów i podziału ruchu nie można zmienić: wymieszałoby to już zebrane wyniki. Aby sprawdzić inne warianty, utwórz nowy test.",
  "Test name": "Nazwa testu",
  "Test description": "Opis testu",
  "Confidence level, %": "Poziom ufności, %",
  "Minimum sample size": "Minimalna próba",
  "Auto-optimization": "Automatyczna optymalizacja",
  "The test is running: the changes apply right away.": "Test trwa: zmiany zadziałają od razu.",
  "A/B test saved": "Test A/B zapisany",
  "Could not save the A/B test": "Nie udało się zapisać testu A/B",
  "Edit domain pool": "Edytuj pulę domen",
  "Links already given out keep working; the changes apply to new links.": "Już wydane linki nadal działają; zmiany dotyczą nowych linków.",
  "Pool name": "Nazwa puli",
  "Pool strategy": "Strategia puli",
  "Pool domains": "Domeny puli",
  "Choose at least one domain.": "Wybierz co najmniej jedną domenę.",
  "Pool description": "Opis puli",
  "Domain pool saved": "Pula domen zapisana",
  "Could not save the domain pool": "Nie udało się zapisać puli domen",
  "Edit connection": "Edytuj połączenie",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Tokeny nie są pokazywane. Aby wymienić token, użyj Odśwież token albo połącz konto ponownie.",
  "Connection name": "Nazwa połączenia",
  "Import cost from this account": "Importuj koszty z tego konta",
  "Off: cost sync skips this account; the connection is kept.": "Wyłączone: synchronizacja kosztów pomija to konto; połączenie zostaje.",
  "Connection saved": "Połączenie zapisane",
  "Could not save the connection": "Nie udało się zapisać połączenia",
  "Edit item": "Edytuj",
};

const tr = {
  "Edit A/B test": "A/B testini düzenle",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Varyantlar ve trafik dağılımı değiştirilemez: bu, toplanmış sonuçları karıştırır. Başka varyantları denemek için yeni bir test oluşturun.",
  "Test name": "Test adı",
  "Test description": "Test açıklaması",
  "Confidence level, %": "Güven düzeyi, %",
  "Minimum sample size": "Minimum örneklem",
  "Auto-optimization": "Otomatik optimizasyon",
  "The test is running: the changes apply right away.": "Test çalışıyor: değişiklikler hemen uygulanır.",
  "A/B test saved": "A/B testi kaydedildi",
  "Could not save the A/B test": "A/B testi kaydedilemedi",
  "Edit domain pool": "Alan adı havuzunu düzenle",
  "Links already given out keep working; the changes apply to new links.": "Verilmiş bağlantılar çalışmaya devam eder; değişiklikler yeni bağlantılara uygulanır.",
  "Pool name": "Havuz adı",
  "Pool strategy": "Havuz stratejisi",
  "Pool domains": "Havuz alan adları",
  "Choose at least one domain.": "En az bir alan adı seçin.",
  "Pool description": "Havuz açıklaması",
  "Domain pool saved": "Alan adı havuzu kaydedildi",
  "Could not save the domain pool": "Alan adı havuzu kaydedilemedi",
  "Edit connection": "Bağlantıyı düzenle",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Belirteçler gösterilmez. Bir belirteci değiştirmek için Belirteci yenile’yi kullanın veya hesabı yeniden bağlayın.",
  "Connection name": "Bağlantı adı",
  "Import cost from this account": "Bu hesaptan maliyetleri içe aktar",
  "Off: cost sync skips this account; the connection is kept.": "Kapalı: maliyet senkronizasyonu bu hesabı atlar; bağlantı korunur.",
  "Connection saved": "Bağlantı kaydedildi",
  "Could not save the connection": "Bağlantı kaydedilemedi",
  "Edit item": "Düzenle",
};

const uk = {
  "Edit A/B test": "Змінити A/B-тест",
  "Variants and the traffic split cannot be changed: that would mix the results already collected. To try other variants, create a new test.": "Варіанти й розподіл трафіку змінювати не можна: це змішає вже зібрані результати. Щоб перевірити інші варіанти, створіть новий тест.",
  "Test name": "Назва тесту",
  "Test description": "Опис тесту",
  "Confidence level, %": "Рівень довіри, %",
  "Minimum sample size": "Мінімальна вибірка",
  "Auto-optimization": "Автооптимізація",
  "The test is running: the changes apply right away.": "Тест запущено: зміни застосуються одразу.",
  "A/B test saved": "A/B-тест збережено",
  "Could not save the A/B test": "Не вдалося зберегти A/B-тест",
  "Edit domain pool": "Змінити пул доменів",
  "Links already given out keep working; the changes apply to new links.": "Уже видані посилання продовжують працювати; зміни стосуються нових посилань.",
  "Pool name": "Назва пулу",
  "Pool strategy": "Стратегія пулу",
  "Pool domains": "Домени пулу",
  "Choose at least one domain.": "Виберіть хоча б один домен.",
  "Pool description": "Опис пулу",
  "Domain pool saved": "Пул доменів збережено",
  "Could not save the domain pool": "Не вдалося зберегти пул доменів",
  "Edit connection": "Змінити підключення",
  "Tokens are not shown. To replace a token, use Refresh token or connect the account again.": "Токени не показуються. Щоб замінити токен, натисніть «Оновити токен» або підключіть акаунт заново.",
  "Connection name": "Назва підключення",
  "Import cost from this account": "Завантажувати витрати з цього акаунта",
  "Off: cost sync skips this account; the connection is kept.": "Вимкнено: синхронізація витрат пропускає акаунт, підключення зберігається.",
  "Connection saved": "Підключення збережено",
  "Could not save the connection": "Не вдалося зберегти підключення",
  "Edit item": "Змінити",
};

const EDIT_DIALOGS = { ru, es, pt, de, fr, it, pl, tr, uk };
export default EDIT_DIALOGS;
